import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_LIGNES} from "../constants/endpoints";

let store = {
  debug: true,
  state: {
    lignes: []
  },

  getAll() {
    if (this.state.lignes.length === 0) {
      return axios.get(ENDPOINT_LIGNES)
          .then(response => {
            this.state.lignes = response.data;
            return this.state.lignes;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.lignes);
      });
    }
  }
};

export default store;
